export default __webpack_public_path__ + "static/media/180.7f8338d2.png";